import React from 'react'

function RoomReassignment() {
  return (
    <span>
      Isha preserves the rights to deny campus access to anyone based on its own
      discretion. The registration is subject to last minute changes, you will
      be informed through the contact details you provide and the respective
      refund or transfer will be done without any additional fee.
    </span>
  )
}

export default RoomReassignment



// WEBPACK FOOTER //
// ./src/components/content/roomReassignment.js